import React from 'react';

const LoadingSpinnerAlt = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="relative w-20 h-20 animate-spin rounded-full bg-gradient-to-r from-gray-900 via-primary-500 to-white-50">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white-50 rounded-full border-2 border-white"></div>
      </div>
    </div>
  );
};

export default LoadingSpinnerAlt;
